import { useTranslation } from "react-i18next";
import React, { useMemo } from "react";
import { ModifyDetail } from "../../../../redux/apiSpecifications/apiSubjects";

interface ISubjectModifiedDescriptionProps {
    modifyDetailsJson: ModifyDetail[];
}

type MapEntry = {
    field: string;
    oldValue: string;
    newValue: string;
};

const SubjectModifiedDescription = ({ modifyDetailsJson }: ISubjectModifiedDescriptionProps) => {
    const { t } = useTranslation();

    const translateValue = (field: string, value: string) => {
        if (value === "[NULL]") {
            return t("historical-actions-field-null-value");
        }
        if (field === "gender") {
            return t(`gender-${value}`);
        }
        if (field === "birth_date" && ["", "01/01/0001"].includes(value)) {
            return t("historical-actions-date-field-no-value");
        }
        return value;
    };

    const getDescription: string[] = useMemo(() => {
        let descriptions: string[] = [];
        let map = new Map();

        modifyDetailsJson.forEach((element) => {
            const splitOldNew = element.key!.split("-");
            let field = splitOldNew[0];

            let mapEntry: MapEntry;

            if (map.has(field)) {
                mapEntry = map.get(field);
            } else {
                mapEntry = {
                    field: field,
                    oldValue: "",
                    newValue: "",
                };
                map.set(field, mapEntry);
            }

            if (splitOldNew[1] === "old") {
                mapEntry.oldValue = element.value!;
            } else {
                mapEntry.newValue = element.value!;
            }
        });

        map.forEach((value: MapEntry) => {
            const fieldTranslation = t(`HISTORY-TEMPLATES.policy-subject-field-${value.field}`);

            let dictionaryKey = "HISTORY-TEMPLATES.policy-subject-modified-description";

            descriptions.push(
                t(dictionaryKey, {
                    field_name: fieldTranslation,
                    old_value: translateValue(value.field, value.oldValue),
                    new_value: translateValue(value.field, value.newValue),
                })
            );
        });

        return descriptions;
    }, [modifyDetailsJson, t]);

    return (
        <>
            {getDescription.map((description, index) => (
                <React.Fragment key={index}>
                    {description}
                    <br />
                </React.Fragment>
            ))}
        </>
    );
};

export default SubjectModifiedDescription;
